import React from 'react';
export function FooterSection() {
  return <footer className="w-full bg-petroleo py-10 px-5 flex justify-center text-center" data-id="element-43">
      <div className="w-full max-w-md flex flex-col items-center gap-6" data-id="element-44">
        <span className="font-serif font-bold text-white text-xl tracking-tight" data-id="element-45">
          Biología Femenina
        </span>

        <p className="text-salvia-light text-xs leading-relaxed max-w-[280px] opacity-80" data-id="element-46">
          Contenido educativo. No reemplaza la consulta médica.
        </p>

        <a href="#" className="text-white text-sm font-medium underline underline-offset-4 decoration-salvia hover:text-salvia-light transition-colors" data-id="element-47">
          Contacto por WhatsApp
        </a>

        <div className="w-full h-px bg-white/10 mt-2 mb-2" data-id="element-48"></div>

        <p className="text-white/50 text-xs" data-id="element-49">© 2025 Biología Femenina</p>
      </div>
    </footer>;
}